import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const CreateTagButton = styled.div`
    width: 196px;
    height: 46px;
    background-color: #151514;
    color: #fff;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    border-radius: 3px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        width: 136px;
        height: 36px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        width: 100%;
        height: 36px;
    }
`;

export const CreateTagWrapper = styled(FlexBox)`
    margin-top: 40px;
    flex-flow: column;
    width: 100%;
    max-width: 1152px;
    z-index: 100;

    .geo-input input {
        padding-left: 44px;
    }

    .search-wrapper_second, .search-wrapper {
        height: 48px !important;
    }

    .input-text input, .input-wrapper {
        width: 100%;
        background-color: rgba(242, 242, 242, 1);
        color: #151514;
        outline: none;
        border-radius: 3px;
        height: 48px !important;
        border: 1px solid transparent;

        &::placeholder {
            color: rgba(182, 182, 181, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }

        &:focus, &:active {
            border: 1px solid #151514;
            border-radius: 3px;
        }

        &:hover {
            &::placeholder {
                color: rgba(182, 182, 181, 1);
                font-size: 17px;
                line-height: 22px;
                font-weight: 400;
            }
        }
    }

    .input-wrapper {

        input {
            ::placeholder {
                color: rgba(182, 182, 181, 1);
                font-size: 17px;
                line-height: 22px;
                font-weight: 400;
            }
        }
        &:hover {
            border: 1px solid #151514;
        }
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 100%;
    }
`;

export const CreateTagModalWrapper = styled(CreateTagWrapper)`
    max-width: 1152px;
`;

export const Title = styled(FlexBox)`
    font-size: 30px;
    line-height: 33px;
    font-weight: 600;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 23px;
        line-height: 27px;
        font-weight: 600;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 20px;
        line-height: 25px;
        font-weight: 600;
    }
`;

export const Label = styled.span<{ mb?: number }>`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
    margin-bottom: ${({ mb }) => mb ? `${mb}px` : '12px'};

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
    }

`;

export const SubmitButton = styled.button`
    width: 127px;
    height: 36px;
    background-color: #151514;
    color: #fff;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    border-radius: 3px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    border-color: transparent;

    &:disabled {
        background-color: rgba(231, 231, 231, 1);
        color: rgba(182, 182, 181, 1);
        pointe-events: none;
        cursor: normal;
    }
`;

export const PointResultContainer = styled(FlexBox)`
    width: 100%;
    height: auto;
    flex-flow: column;

    .point-item {
        &:hover {
            background-color: #e7e7e7;

            * {
                background-color: #e7e7e7;
                transition: background-color 0.2s;
            }
        }
    }

`;

export const CloseIconWrapper = styled(FlexBox)<{ hide?: boolean, collapse?: boolean }>`
    position: absolute;
    bottom: 15.5px;
    right: 16px;
    cursor: pointer;
    ${({ hide }) => hide && css`
        visibility: hidden;
    `};

    ${({ collapse }) => collapse && css`
        bottom: 0;
        top: 47px;
    `};

    svg path {
        fill: rgba(144, 144, 144, 1);
        transition: fill 0.2s;
    }

    svg {
        :hover {
            path {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }
`;

export const SearchIconWrapper = styled(FlexBox)<{ collapse?: boolean }>`
    position: absolute;
    bottom: 15.5px;
    left: 16px;
    z-index: 99;

    ${({ collapse }) => collapse && css`
        bottom: 0;
        top: 50px;
    `};

    svg path {
        fill: rgba(144, 144, 144, 1);
        transition: fill 0.2s;
    }
`;import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const CreateTagButton = styled.div`
    width: 196px;
    height: 46px;
    background-color: #151514;
    color: #fff;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    border-radius: 3px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        width: 136px;
        height: 36px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        width: 100%;
        height: 36px;
    }
`;

export const CreateTagWrapper = styled(FlexBox)`
    margin-top: 40px;
    flex-flow: column;
    width: 100%;
    max-width: 1152px;
    z-index: 100;

    .geo-input input {
        padding-left: 44px;
    }

    .search-wrapper_second, .search-wrapper {
        height: 48px !important;
    }

    .input-text input, .input-wrapper {
        width: 100%;
        background-color: rgba(242, 242, 242, 1);
        color: #151514;
        outline: none;
        border-radius: 3px;
        height: 48px !important;
        border: 1px solid transparent;

        &::placeholder {
            color: rgba(182, 182, 181, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }

        &:focus, &:active {
            border: 1px solid #151514;
            border-radius: 3px;
        }

        &:hover {
            &::placeholder {
                color: rgba(182, 182, 181, 1);
                font-size: 17px;
                line-height: 22px;
                font-weight: 400;
            }
        }
    }

    .input-wrapper {

        input {
            ::placeholder {
                color: rgba(182, 182, 181, 1);
                font-size: 17px;
                line-height: 22px;
                font-weight: 400;
            }
        }
        &:hover {
            border: 1px solid #151514;
        }
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 100%;
    }
`;

export const CreateTagModalWrapper = styled(CreateTagWrapper)`
    max-width: 1152px;
`;

export const Title = styled(FlexBox)`
    font-size: 30px;
    line-height: 33px;
    font-weight: 600;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 23px;
        line-height: 27px;
        font-weight: 600;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 20px;
        line-height: 25px;
        font-weight: 600;
    }
`;

export const Label = styled.span<{ mb?: number }>`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
    margin-bottom: ${({ mb }) => mb ? `${mb}px` : '12px'};

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
    }

`;

export const SubmitButton = styled.button`
    width: 127px;
    height: 36px;
    background-color: #151514;
    color: #fff;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    border-radius: 3px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    border-color: transparent;

    &:disabled {
        background-color: rgba(231, 231, 231, 1);
        color: rgba(182, 182, 181, 1);
        pointe-events: none;
        cursor: normal;
    }
`;

export const PointResultContainer = styled(FlexBox)`
    width: 100%;
    height: auto;
    flex-flow: column;

    .point-item {
        &:hover {
            background-color: #e7e7e7;

            * {
                background-color: #e7e7e7;
                transition: background-color 0.2s;
            }
        }
    }

`;

export const CloseIconWrapper = styled(FlexBox)<{ hide?: boolean, collapse?: boolean }>`
    position: absolute;
    bottom: 15.5px;
    right: 16px;
    cursor: pointer;
    ${({ hide }) => hide && css`
        visibility: hidden;
    `};

    ${({ collapse }) => collapse && css`
        bottom: 0;
        top: 47px;
    `};

    svg path {
        fill: rgba(144, 144, 144, 1);
        transition: fill 0.2s;
    }

    svg {
        :hover {
            path {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }
`;

export const SearchIconWrapper = styled(FlexBox)<{ collapse?: boolean }>`
    position: absolute;
    bottom: 15.5px;
    left: 16px;
    z-index: 99;

    ${({ collapse }) => collapse && css`
        bottom: 0;
        top: 50px;
    `};

    svg path {
        fill: rgba(144, 144, 144, 1);
        transition: fill 0.2s;
    }
`;